interface Module {
  number: string;
  title: string;
}

interface Bonus {
  icon: string;
  text: string;
}

interface CourseIncludesProps {
  modules: Module[];
  bonuses?: Bonus[];
  courseName?: string;
  totalHours?: string;
}

const defaultBonuses: Bonus[] = [
  { icon: "ri-whatsapp-line", text: "Scripts e prompts prontos de WhatsApp para varejo" },
  { icon: "ri-file-text-line", text: "Planilhas de gerenciamento de metas e gestão no Excel" },
  { icon: "ri-video-line", text: "Aula bônus: VEO3, Chapgpt, Gemni e outros" },
  { icon: "ri-group-line", text: "Grupo VIP no WhatsApp com Gleice além das aulas mensais de duvidas e implantação para melhorar os resultados" },
];

export default function CourseIncludes({
  modules,
  bonuses = defaultBonuses,
  totalHours = "+30",
}: CourseIncludesProps) {
  return (
    <section className="py-20 px-6 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 max-w-xl">
          <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-3">Conteúdo do Curso</p>
          <h2 className="text-3xl md:text-4xl font-light text-black tracking-tight">
            O que você vai aprender
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            {modules.length} módulos completos com mais de {totalHours} horas de conteúdo prático e aplicável ao seu dia a dia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border border-gray-100 mb-20">
          {modules.map((mod, idx) => (
            <div
              key={mod.number}
              className={`p-6 border-gray-100 hover:bg-[#faf9f7] transition-all duration-200 group
                ${idx % 4 !== 3 ? "border-r" : ""}
                ${idx < modules.length - 4 ? "border-b" : ""}
              `}
            >
              <span className="text-[#b8962e] text-xs tracking-widest font-semibold mb-3 block">
                {mod.number}
              </span>
              <p className="text-black text-xs font-medium leading-snug tracking-wide group-hover:text-[#b8962e] transition">
                {mod.title}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#111] p-10 md:p-14">
          <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-2">Bônus Exclusivos</p>
          <h3 className="text-white text-2xl font-light mb-8 tracking-tight">
            Tudo isso também está incluído
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {bonuses.map((b, i) => (
              <div key={i} className="flex items-start gap-4">
                <span className="w-9 h-9 flex items-center justify-center border border-[#b8962e]/40 shrink-0">
                  <i className={`${b.icon} text-[#b8962e] text-base`}></i>
                </span>
                <p className="text-white/70 text-sm leading-relaxed pt-1">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
